import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Mail } from 'lucide-react';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <Header />
      
      <main className="pt-40 pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <h1 className="font-display text-display-sm text-charcoal-900 mb-2">Reset Password</h1>
            <p className="text-charcoal-500">We'll send you a reset link</p>
          </div>
          
          <div className="bg-white border border-cream-200 p-8">
            {submitted ? (
              <div className="text-center">
                <div className="w-14 h-14 bg-charcoal-900 flex items-center justify-center mx-auto mb-6">
                  <Mail className="w-6 h-6 text-cream-50" />
                </div>
                <h2 className="font-display text-lg text-charcoal-900 mb-2">Check Your Email</h2>
                <p className="text-charcoal-500 text-sm mb-6">
                  We've sent a password reset link to <strong>{email}</strong>
                </p>
                <Link to="/login" className="text-bronze-600 hover:text-bronze-700 text-sm font-medium">
                  Return to sign in
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label className="text-sm text-charcoal-600">Email Address</Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-2 bg-cream-50 border-charcoal-200 focus:border-charcoal-900"
                    placeholder="your@email.com"
                    required
                  />
                </div>
                
                <button type="submit" className="w-full btn-primary">
                  Send Reset Link
                </button>
              </form>
            )}
          </div>
          
          <Link 
            to="/login" 
            className="flex items-center justify-center gap-2 mt-6 text-charcoal-500 hover:text-charcoal-900 text-sm transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to sign in
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
